import React from 'react';
import Typography from '../typography';

import styles from './index.module.css';

const QuestionSubheading = ({ children }) => (
  <Typography variant='bodyBase' align='left' color='var(--text-secondary)' className={styles.subheading}>
    {children}
  </Typography>
);

export default QuestionSubheading;
